<template>
  <div class="about-cnt">
    <div class="ty-banner-1">
      <img
        alt="河南万杰智能科技股份"
        src="@img/subpage-banner.jpg"
        title="河南万杰智能科技股份"
      />
    </div>
    <search-bar></search-bar>
    <div class="blk-main content clearafter">
      <div class="blk plc">
        <div class="p12-curmbs-1" navcrumbs="">
          <b>您的位置:</b>
          <router-link to="/">主页</router-link>
          &gt;
          <router-link to="/case">成功案例</router-link>
          &gt;
          <router-link :to="route.path">{{ route.name }}</router-link>
          &gt;
        </div>
      </div>
      <div class="clear"></div>
      <div class="blk-md">
        <div class="tl-fdh-02 blk">
          <ul>
            <li v-for="(data, index) in routes" :key="index">
              <router-link active-class="sidenavcur" :to="'/case/' + data.path">
                <span>{{ data.name }}</span>
              </router-link>
            </li>
          </ul>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
        <router-view />
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import searchBar from "../common/searchBar.vue";
export default {
  data() {
    return {
      route: this.$route
    };
  },
  components: {
    searchBar
  },
  mounted() {},
  watch: {
    $route: "getRoute"
  },
  methods: {
    getRoute() {
      // console.log(this.$route);
      this.route = this.$route;
    }
  },
  computed: {
    routes() {
      var routes = {
        children: this.$router.options.routes
      };

      var route = this.$route.matched;

      for (var i = 0; i < route.length - 1; i++) {
        routes = routes.children.find(e => e.name == route[i].name);
      }
      return routes.children;
    }
  }
};
</script>

<style lang="less">
@import "~@css/warp.less";
.about-cnt {
  background: rgba(247, 247, 247, 1);
  padding-bottom: 80px;

  .tl-fdh-02 {
    height: 55px;
    background: #fff;
    margin-bottom: 20px;
    overflow: hidden;
    li {
      width: 14.28%;
      height: 55px;
      font-size: 18px;
      line-height: 55px;
      text-align: center;
      float: left;
      box-sizing: border-box;
      background: #fff;
      cursor: pointer;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      &:last-child {
        a {
          border-right: 0;
        }
      }
      a {
        color: rgba(102, 102, 102, 1);
        border-right: 1px solid rgba(238, 238, 238, 1);
        display: block;
        &:hover,
        &.sidenavcur {
          background: url(~@img/p16-icon6.png) no-repeat bottom center
            rgba(19, 181, 179, 1);
          border-color: rgba(19, 181, 179, 1);
          span {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/case/index.vue